module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACxSURBVCiR7Y6xDcIwFAXfy/ceZAMyQkpEkELhgo7IYoAwQcQIDICAnpaeERgBNsgC1qdJkVhRsKi5xvLpnWygR2FdXVhXI2DMJ4MFWYIsw3DMc7GpUvHSAEgBZJ1/Bmnfv7z4gxEvZwB5MAzvAy9esmRiNEWWfN+MY7rzQuU1JlDqFkBlAEBV3/fb6RETLq3LSeLnr/7DCQyAFuR8ZXd5TKDUGYDWkDxCtVHqOvo51f0HTFQtdscr2VcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/yy3.png
// module id = jkXc
// module chunks = 1